import { useContext } from 'react';
import { useImmediateLayoutAnimation } from 'use-layout-animation';
import { View } from '@shared/components/View';
import { MBAutosizeTextInput } from '@shared/components/textInput';
import { MBTextBody2 } from '@shared/components/typography';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { MBBlockLabel } from '../../utils/label';
import { renderToggle } from '../input/utils';

interface Props {
  enabled: boolean;
  name: string;
  onToggle(enabled: boolean): void;
  onChangeName(batchName: string): void;
}

export function BatchOptions({ enabled, name, onToggle, onChangeName }: Props) {
  useImmediateLayoutAnimation([enabled]);
  const colors = useContext(ColorThemeContext);
  return (
    <View paddingBottom={2}>
      <View row centerVertically>
        <View flex paddingRight={4}>
          <MBBlockLabel label={i18n('card.blocks.assigneeInput.batchOptions.enable.title')} />
          <MBTextBody2 color={colors.foregroundActive}>
            {i18n('card.blocks.assigneeInput.batchOptions.enable.description')}
          </MBTextBody2>
        </View>
        {renderToggle(enabled, onToggle)}
      </View>
      {enabled && (
        <View paddingTop={2}>
          <MBBlockLabel label={i18n('card.blocks.assigneeInput.batchOptions.name.title')} />
          <MBAutosizeTextInput
            style={{ backgroundColor: colors.backgroundInactive, borderRadius: grid(1) }}
            onChangeText={onChangeName}
            value={name}
            placeholder={i18n('card.blocks.assigneeInput.batchOptions.name.placeholder')}
            autoFocus
            padding="normal"
          />
        </View>
      )}
    </View>
  );
}
